/**
 * Converts canonical ISO 8601 durations made of fixed-length units to seconds.
 */
export const getDurationInSeconds = (duration?: string): number | undefined => {
  if (!duration) {
    return undefined;
  }

  const match = duration.match(
    /^P(?:(\d+(?:\.\d+)?)W|(?:(\d+(?:\.\d+)?)D)?(?:T(?:(\d+(?:\.\d+)?)H)?(?:(\d+(?:\.\d+)?)M)?(?:(\d+(?:\.\d+)?)S)?)?)$/
  );
  if (!match) {
    return undefined;
  }

  const [, weeks, days, hours, minutes, seconds] = match;
  const components = [weeks, days, hours, minutes, seconds];
  const lastComponentIndex = components.findLastIndex((component) => component !== undefined);
  const fractionalComponentIndex = components.findIndex((component) => component?.includes("."));

  if (
    lastComponentIndex === -1 ||
    (duration.includes("T") && !hours && !minutes && !seconds) ||
    (fractionalComponentIndex !== -1 && fractionalComponentIndex !== lastComponentIndex)
  ) {
    return undefined;
  }

  const minutesValue = Number(minutes || 0);
  const secondsValue = Number(seconds || 0);
  if (minutesValue >= 60 || secondsValue >= 60) {
    return undefined;
  }

  const durationInSeconds =
    Number(weeks || 0) * 604800 +
    Number(days || 0) * 86400 +
    Number(hours || 0) * 3600 +
    minutesValue * 60 +
    secondsValue;

  return Number.isFinite(durationInSeconds) && durationInSeconds > 0 ? durationInSeconds : undefined;
};
